module.exports = __webpack_public_path__ + "img/bkk-wh.7110c4a0.svg";